"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _r10SourceLibrary = require("r10-source-library");
var _includedAppsIcon = _interopRequireDefault(require("./includedAppsIcon"));
var _icons = _interopRequireDefault(require("../../constants/icons"));
var _useTranslation = _interopRequireDefault(require("../../hooks/useTranslation"));
var _constants = require("../../constants");
var _WrapByDataAttributes = _interopRequireDefault(require("../../utils/WrapByDataAttributes"));
var _useProps2 = _interopRequireDefault(require("../../hooks/useProps"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var PlanInclusions = function PlanInclusions() {
  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
      return state[_constants.PKG_NAME];
    }),
    inclusions = _useSelector.inclusions;
  var t = (0, _useTranslation.default)();
  var _useProps = (0, _useProps2.default)(),
    unlimitedValue = _useProps.unlimitedValue;
  var getText = function getText(value, unitOfMeasure, type) {
    var text = '';
    if (value === unlimitedValue) {
      value = t('unlimited');
      unitOfMeasure = null;
    }
    if (type === _constants.DETAILS_SECTIONS.sectionType) {
      text = "".concat(t(_constants.TRANSLATION_MAPPING[type]), " ").concat(value);
    } else {
      var bindings = {};
      bindings.value = value;
      bindings.unitOfMeasure = unitOfMeasure;
      text = value ? "".concat(t(_constants.TRANSLATION_MAPPING[type] || '', bindings)) : "";
    }
    return text;
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, inclusions.map(function (inclusion, i) {
    return /*#__PURE__*/_react.default.createElement(_WrapByDataAttributes.default, {
      "data-testid": inclusion.type,
      key: inclusion.id
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
      marginBottom: 2
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
      spacingLevel: {
        right: 1
      }
    }, (inclusion === null || inclusion === void 0 ? void 0 : inclusion.type) && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Icon, {
      name: _icons.default[inclusion === null || inclusion === void 0 ? void 0 : inclusion.type],
      appearance: "primary",
      size: 5,
      group: "system"
    })), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
      marginBottom: 2,
      justify: "between"
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
      level: 5,
      text: "".concat(getText((inclusion === null || inclusion === void 0 ? void 0 : inclusion.type) === _constants.DETAILS_SECTIONS.sectionType && inclusion !== null && inclusion !== void 0 && inclusion.includedApps ? inclusion === null || inclusion === void 0 ? void 0 : inclusion.id : inclusion === null || inclusion === void 0 ? void 0 : inclusion.value, inclusion === null || inclusion === void 0 ? void 0 : inclusion.unitOfMeasure, inclusion === null || inclusion === void 0 ? void 0 : inclusion.type))
    })), (inclusion === null || inclusion === void 0 ? void 0 : inclusion.type) === _constants.DETAILS_SECTIONS.sectionType && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
      spacingLevel: {
        left: 3,
        top: 3
      }
    }, /*#__PURE__*/_react.default.createElement(_includedAppsIcon.default, {
      includedApps: inclusion === null || inclusion === void 0 ? void 0 : inclusion.includedApps
    }))))), i < inclusions.length - 1 && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Divider, {
      appearance: "secondary"
    })));
  }));
};
var _default = PlanInclusions;
exports.default = _default;